import { BadgeColor } from '@coworkrz/core/types';

export enum ReservationStatus {
  PENDING = 'Pending',
  CONFIRMED = 'Confirmed',
  CANCELLED = 'Cancelled',
}

export const ReservationBadgeColor: { [key in ReservationStatus]: BadgeColor } =
  {
    [ReservationStatus.PENDING]: 'purple',
    [ReservationStatus.CONFIRMED]: 'green',
    [ReservationStatus.CANCELLED]: 'red',
  };
